/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023, 2024.
 */

import { Linkable } from '@/components/blocks/Linkable';
import { storeLocatorInfoBoxSX } from '@/components/content/StoreLocator/styles/infoBox';
import { infoBoxStackLevelOneSX } from '@/components/content/StoreLocator/styles/infoBoxStackLevelOne';
import { infoBoxStackLevelThreeSX } from '@/components/content/StoreLocator/styles/infoBoxStackLevelThree';
import { useStoreLocator } from '@/data/Content/StoreLocator';
import { ContentContext } from '@/data/context/content';
import { useLocalization } from '@/data/Localization';
import { StoreDetails } from '@/data/types/Store';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { FC, useContext, useEffect } from 'react';

export const StoreLocatorInfoBox: FC = () => {
	const {
		hidden,
		clickedIndex,
		stores
	} = useContext(ContentContext) as ReturnType<typeof useStoreLocator> & {
		stores:StoreDetails[]
	};
	
	const storeLocatorRoute = useLocalization('Routes').StoreLocator.route.t();
	const storeDetailsNLS = useLocalization('StoreLocator');
	const store = stores?.at(clickedIndex);
	const storeName = store?.storeName;
	
	
	useEffect(() => {
		const elem = document.getElementById('storeInfoId');
		elem?.scrollIntoView(false);
	}, [storeName]); 

	return (
		<Paper sx={storeLocatorInfoBoxSX(hidden)}>
			<Stack direction="row" spacing={1} sx={infoBoxStackLevelOneSX}>
				{storeName ? (
					<Box id="storeInfoId">
						<Stack sx={infoBoxStackLevelThreeSX} spacing={1}>
							<Typography variant="h6">{storeName}</Typography>
							<Typography variant = "miniBody1">{store.storeFullAddress}</Typography>
							<Typography variant = "miniBody1">{store.postalCode}{store.city}</Typography>
						</Stack>
						<Linkable href={store?.storePageURL??storeLocatorRoute}>
							<Typography variant = "miniBody1">{storeDetailsNLS.storeStreetGoToStore.t()}</Typography>
						</Linkable>
					</Box>
				) : null}
			</Stack>
		</Paper>
	);
};
